import type { ReactNode } from 'react'

import {
  ArtifactCanvasBody,
  ArtifactCanvasFooterBar,
  ArtifactCanvasInlineError,
} from '@/components/artifact/artifact-canvas-layout'
import { cn } from '@/lib/utils'

type RubricArtifactCanvasLayoutProps = {
  children: ReactNode
  actions: ReactNode
  leading?: ReactNode
  inlineError?: ReactNode
  contentClassName?: string
}

/** Matches opportunity/job artifact canvas layout: scroll body + pinned footer inside one shell. */
export function RubricArtifactCanvasLayout({
  children,
  actions,
  leading,
  inlineError,
  contentClassName,
}: RubricArtifactCanvasLayoutProps) {
  return (
    <ArtifactCanvasBody className="flex h-full min-h-0 flex-col space-y-0 p-0">
      <div className={cn('min-h-0 flex-1 space-y-6 overflow-y-auto p-6', contentClassName)}>
        {children}
      </div>
      <ArtifactCanvasInlineError>{inlineError}</ArtifactCanvasInlineError>
      <ArtifactCanvasFooterBar footerClassName="shrink-0" leading={leading} actions={actions} />
    </ArtifactCanvasBody>
  )
}
